<template>
  <div
    class="lego-tree-dropdown lego-dropdown lego-input scpm-tree-dropdown-v3"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-dropdown-click-outside="toggleItemOuter"
    ref="scpmTreeDropdown"
  >
    <div
      class="lego-dropdown__title"
      :class="{ 'lego-dropdown--focused': isFocused }"
      :tabindex="autoComplete || disabled ? -1 : 0"
      @click="toggleItem"
      @keydown.stop="onKeydown"
    >
      <div
        class="lego-dropdown__selected"
        :style="dropdownTitleStyle"
        v-lego-tooltip:ellipsis="getText(selItem)"
      >
        <img :src="productType.icon" width="28" />
        <span class="service-name"
          ><b>{{ productType.name }}</b></span
        >
      </div>
      <lego-icon-wrapper class="lego-dropdown__title-icon">
        <!-- <lego-icon
                          class="lego-dropdown"
                          icon-type="df"
                          :icon="item.expand ? 'arrow_up' : 'arrow_down'"
                          :size:="16"
                   
                        /> -->
        <lego-icon
          class="lego-dropdown"
          icon-type="df"
          icon="arrow_down"
          size="16px"
          :style="caretStyle"
        />
      </lego-icon-wrapper>
    </div>
    <div class="lego-dropdown-menu" v-if="isItemShowing && items.length === 0">
      <div class="no-data">{{ t('label.noData') }}</div>
    </div>
    <div
      class="lego-dropdown__items"
      v-if="isItemShowing && items.length > 0"
      :class="itemsClass"
      ref="lego-dropdown__items"
    >
      <c-scroll
        ref="scrollRef"
        style="
          max-height: 600px;
          background-color: white;
          padding: 8px;
          border: 1px solid #364fc7;
          min-width: 318px;
          border-radius: 4px;
        "
      >
        <lego-accordion-item
          class="scpm-tree-dropdown-child"
          v-for="(item, index) in items"
          :title="item.text"
          :key="index"
          :index="checkExpand(item) ? 0 : 1"
          :expand="checkExpand(item)"
          expandable
        >
          <template #title>
            <slot name="title" :item="item">
              <div class="lego-tree-dropdown__title">
                <img :src="item.icon" width="15" height="15px" />
                <strong>{{ item.text }} ({{ item.childItems.length || 0 }})</strong>
              </div>
            </slot>
          </template>
          <template #expand>
            <slot name="expand" :item="item">
              <div
                class="lego-dropdown__item"
                :class="{
                  'lego-dropdown__item--focused': idx === focusedItemIndex,
                  'lego-dropdown__item--active': isSelectedItem(childItem),
                  'lego-dropdown__item--sub': childItem.isSub
                }"
                v-for="(childItem, idx) in item.childItems"
                @click.stop="clickItem({ ...childItem, item })"
                :key="idx"
              >
                <ScpmSubTreeDropdownV3
                  v-if="childItem.isSub"
                  :item="item"
                  :items="childItem.childItems"
                  :childItem="childItem"
                  :title="childItem.text"
                  @click="clickItem"
                  v-model="productTypeSelected"
                  ref="dropdownSub"
                />
                <div
                  v-else
                  class="lego-dropdown__label"
                  :class="{ 'lego-dropdown__selected': isSelectedItem(childItem) }"
                  :id="`dropdown-child-${childItem.typeOrder}`"
                >
                  <span v-lego-tooltip:ellipsis="getText(childItem)" class="ellipsis">
                    <slot name="itemText" :item="childItem" :getText="getText">{{
                      getText(childItem)
                    }}</slot>
                  </span>
                </div>
              </div>
            </slot>
          </template>
        </lego-accordion-item>
      </c-scroll>
    </div>
    <div
      v-if="messageShow"
      class="lego-dropdown__message lego-validator__message"
      :class="messageClass"
      :style="customValidationStyle"
    >
      {{ messageShow }}
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import legoDropdown from '@/lego-component/components/element/legoDropdown/legoDropdown.vue';
import cScroll from '../../cmp/cScroll/cScroll.vue';
import ScpmSubTreeDropdownV3 from './ScpmSubTreeDropdownV3';
import ScpmTreeDropdown from './ScpmTreeDropdown';
import { mapActions } from 'vuex';

export default {
  mixins: [i18nMixin, ScpmTreeDropdown],
  name: 'scpm-tree-dropdown-v3',
  components: { cScroll, ScpmSubTreeDropdownV3 },
  emits: ['changeProductType', 'productTypeSelected'],
  extends: legoDropdown,
  data() {
    return {
      productType: {
        icon: '',
        serviceName: ''
      },
      productTypeSelected: 'VM'
    };
  },
  watch: {
    modelValue: {
      handler(newValue, value) {
        if (newValue) {
          const item = this.flatItems(this.items).find((item) => item.productTypeCode === newValue);
          this.getSelected(item.icon, item.text);
          this.$emit('productTypeSelected', this.productType);
          this.productTypeSelected = newValue;
          if (newValue !== value) {
            this.setProductTypeAction(this.productTypeSelected);
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  computed: {
    selItem() {
      return this.itemsMap.get(this.productTypeSelected);
    }
  },

  methods: {
    ...mapActions('productType', ['setProductTypeAction']),
    flatItems(items) {
      const itemList = [...items];
      const flatArr = [];
      const flatFunc = (flatItem, icon) => {
        for (let item of flatItem) {
          if (!item.icon) {
            item.icon = icon;
          }
          if (item.childItems && item.childItems.length > 0) {
            flatFunc(item.childItems, item.icon);
          } else {
            flatArr.push(item);
          }
        }
      };
      flatFunc(itemList);
      return flatArr;
    },
    checkExpand(item) {
      return this.isExpand && this.isExpand.toLowerCase() == item.value.toLowerCase();
    },

    getSelected(icon, name) {
      this.productType.icon = icon;
      this.productType.name = name;

      this.$store.commit('setInconProductType', icon);
    },

    clickItem(selected) {
      if (selected.expend || selected.isSub) return;
      let notIcon = _.isEmpty(selected.item);
      if (notIcon) {
        selected.item.icon = this.items.filter((e) => e.value == selected.groupName)[0].icon;
      }

      this.getSelected(selected.item.icon, selected.text);
      this.productTypeSelected = selected.value;
      this.isSelectedItem(selected);
      this.$emit('changeProductType', selected);

      if (this.autoComplete) {
        this.toggleItemOuter();
      } else {
        this.toggleItem();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
:deep .simplebar-content {
  border: none !important;
}

.scpm-tree-dropdown-v3 {
  height: 40px;
  width: auto;
  &:hover {
    .service-name {
      color: #2c59d9;
      text-decoration: underline;
    }
  }

  .lego-dropdown__title {
    border: none;
    padding-left: 0px;
  }

  .lego-dropdown__title:focus {
    border: none;
  }

  .service-name {
    margin-left: 12px;
    font-size: 18px;
  }

  .lego-dropdown__item {
    border-radius: 4px;
    .lego-dropdown__label .icon {
      display: none;
    }

    .lego-dropdown__label {
      padding: 6px 37px 6px 33px !important;
      border-radius: 4px;
    }

    .lego-dropdown__label:not(.lego-dropdown__selected):hover {
      background-color: #eef2fc;
      border-radius: 4px;
    }
  }

  .lego-dropdown__item:hover {
    .lego-dropdown__label .icon {
      display: block;
    }
  }
}

.lego-dropdown {
  &__title {
    border-radius: 2px;

    &:focus {
      border: $lego-dropdown__title__border;
    }

    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }
  &__selected {
    width: unset !important;
  }
}

.lego-dropdown-menu {
  position: absolute;
  border: 1px solid #364fc7;
  min-width: 100%;
  margin-top: 0px;
  background-color: #ffffff;
  z-index: 200;
  cursor: default;
  padding: 25px 0;
  text-align: center;
  font-size: 11px;
  color: #767676;
}

.accordion-list-item {
  margin-top: 0px !important;
}

.lego-tree-dropdown {
  &__title {
    display: flex;
    align-items: center;

    strong {
      display: block;
      margin-left: 8px;
      font-weight: 500;
    }
  }

  .lego-dropdown__items {
    z-index: 1002;

    .lego-dropdown__item {
      padding: 0;

      &--active {
        background-color: #e1e7f9;
        border-radius: 4px;
      }

      &--sub {
        background-color: #ffffff;
      }
    }

    .lego-dropdown {
      &__selected {
        font-weight: 500;
        color: #364fc7;
      }

      &__label {
        min-height: 30px;
        padding-left: 31px;
      }
    }

    border: none !important;
  }

  :deep .accordion-list-item {
    border: none;

    &__main {
      display: flex;
      justify-content: space-between;
      padding: 0 0 0 8px !important;
    }

    &__expand {
      border-top: 0 !important;
      margin: 0 !important;
      padding: 0;
    }
  }

  .lego-dropdown__item:last-child {
    border-radius: 4px !important;
  }

  .lego-dropdown__item--sub {
    :deep .accordion-list-item {
      &__main {
        padding-left: 33px !important;
      }
    }
  }

  .lego-dropdown__item--sub {
    :deep .scpm-sub-tree-v3 {
      .expand-icon {
        padding: 6px 10px 6px 10px !important;
      }
    }
  }
}
:deep .simplebar-mask {
  border-radius: 4px;
}
</style>
